"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var common_1 = require("@angular/common");
var rating_config_1 = require("./rating-config");
var rating_1 = require("./rating");
var rating_2 = require("./rating");
exports.NgbRating = rating_2.NgbRating;
var rating_config_2 = require("./rating-config");
exports.NgbRatingConfig = rating_config_2.NgbRatingConfig;
var NgbRatingModule = /** @class */ (function () {
    function NgbRatingModule() {
    }
    NgbRatingModule_1 = NgbRatingModule;
    NgbRatingModule.forRoot = function () { return { ngModule: NgbRatingModule_1, providers: [rating_config_1.NgbRatingConfig] }; };
    NgbRatingModule = NgbRatingModule_1 = __decorate([
        core_1.NgModule({ declarations: [rating_1.NgbRating], exports: [rating_1.NgbRating], imports: [common_1.CommonModule] })
    ], NgbRatingModule);
    return NgbRatingModule;
    var NgbRatingModule_1;
}());
exports.NgbRatingModule = NgbRatingModule;
//# sourceMappingURL=rating.module.js.map


//////////////////
// WEBPACK FOOTER
// ./temp/rating/rating.module.js
// module id = 68
// module chunks = 0